import React from 'react'
import {Card} from '../components/Card'
import {Typography} from '../components/Typography'
import {Button} from '../components/Button'

const getProfessorName = (professors = []) => {
  const professor = professors[0] || {}
  return professor.professorName
}

const PosCourseCard = ({
  cover: image,
  title,
  titleCard,
  subtitle,
  slug,
  investiment: {investmentOldValue, investmentValue},
}) => {
  return (
    <Card>
      <Card.Image src={image} />
      <Card.Content>
        <Card.Title title={title}>{titleCard}</Card.Title>

        <Typography
          color="gray-900"
          className="pb-4 overflow-hidden truncate whitespace-nowrap"
        >
          {subtitle}
        </Typography>

        <Typography color="gray-900" uppercase className="line-through">
          de R$ {investmentOldValue}
        </Typography>

        <Typography color="gray-900" uppercase weight="black">
          Por apenas R${' '}
          <Typography as="strong" size="xl" uppercase weight="black">
            {investmentValue}
          </Typography>
        </Typography>
      </Card.Content>
      <Card.Action>
        <Button as="a" fullWidth className="uppercase" href={`/${slug}`}>
          detalhes da pós
        </Button>
      </Card.Action>
    </Card>
  )
}

export {PosCourseCard}
